import { RootState } from 'shared/config/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectIsAuthModalOpen = (state: RootState) => state.app.isAuthModalOpen
export const selectAuthModalType = (state: RootState) => state.app.authModalType
export const selectIsConfirmationSendToModalOpen = (state: RootState) => state.app.isConfirmationSendToModalOpen
export const selectIsConfirmationErrorModalOpen = (state: RootState) => state.app.isConfirmationErrorModalOpen
export const selectIsConfirmationSuccessModalOpen = (state: RootState) => state.app.isConfirmationSuccessModalOpen
export const selectSendToEmail = (state: RootState) => state.app.sendToEmail
export const selectExpireDate = (state: RootState) => state.app.expireDate
export const selectIsCreateTeamModalOpen = (state: RootState) => state.app.isCreateTeamModalOpen
export const selectIsJoinTeamModalOpen = (state: RootState) => state.app.isJoinTeamModalOpen
export const selectIsForgotPassModalOpen = (state: RootState) => state.app.isForgotPassModalOpen
export const selectIsInviteMembersModalOpen = (state: RootState) => state.app.isInviteMembersModalOpen
export const selectIsAddNewBoardModalOpen = (state: RootState) => state.app.isAddNewBoardModalOpen
export const selectIsSelectTargetBoardToUploadModalOpen = (state: RootState) => state.app.isSelectTargetBoardToUploadModalOpen
export const selectModalType = (state: RootState) => state.app.modalType
export const selectRenamingBoardId = (state: RootState) => state.app.renamingBoardId
export const selectModalBoardData = (state: RootState) => state.app.modalBoardData
export const getAvailableExtensionsForUploading = (state: RootState) => state.app.extensionAvailableForUploading
export const selectAuthModalMode = (state: RootState) => state.app.authModalMode
export const selectEmailVerificationEmail = (state: RootState) => state.app.emailVerification.email
export const selectAuthModalInPublicLink = (state: RootState) => state.app.authModalInPublicLink
export const selectSortingOptions = (state: RootState) => state.app.sortingOptions
export const selectSortOrder = (state: RootState) => state.app.sortOrder
export const selectDefaultSortingOption = (state: RootState) => state.app.defaultSortingOption
export const selectSelectedSort = (state: RootState) => state.app.selectedSort
export const selectAppId = (state: RootState) => state.app.appId
export const selectIsPlansModalOpen = (state: RootState) => state.app.isPlansModalOpen

export const selectAiBotAvatarPath = createSelector(selectAppId,(appId) => {
  return appId === 'aivard' ? '/icons/aivard-avatar.svg' : '/icons/yagel/yagel-avatar.png'
})
